import { render } from "./news_details.vue?vue&type=template&id=e6aa6cf0"
import script from "./news_details.vue?vue&type=script&lang=js"
export * from "./news_details.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__